/* ==========================================================================
   Sparvya — theme.js

   IMPORTANT: there is deliberately NO AJAX add-to-cart here.
   Shopify file inputs (the customer's photo) only survive a standard HTML
   form POST. An AJAX cart JSON.stringify's the FormData and silently drops
   the file — you would get orders with no photograph. Do not add one.
   ========================================================================== */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Mobile menu ---------- */

  var menuBtn = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Scroll reveals ---------- */

  var reveals = document.querySelectorAll('.reveal');

  if (reduced || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Gallery thumbnails ---------- */

  var main = document.getElementById('galleryMain');
  var thumbs = document.querySelectorAll('.gallery__thumb');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!main) return;
      main.src = thumb.dataset.full;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    });
  });

  /* ---------- Variant selection ----------
     The <select name="id"> is the real form control and always works.
     The buttons are progressive enhancement: shown only once JS runs,
     and they simply drive the select. If this script fails, the select
     stays visible and the form still submits correctly.               */

  var select = document.querySelector('[data-variant-select]');
  var buttonWrap = document.querySelector('[data-variant-buttons]');

  function formatMoney(paise) {
    var rupees = paise / 100;
    var str = rupees % 1 === 0 ? rupees.toFixed(0) : rupees.toFixed(2);
    return '₹' + Number(str).toLocaleString('en-IN');
  }

  function syncPrice() {
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;

    var price = parseInt(opt.dataset.price, 10);
    var compare = parseInt(opt.dataset.compare, 10);
    if (isNaN(price)) return;

    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var barPrice = document.querySelector('[data-buybar-price]');

    if (priceEl) priceEl.textContent = formatMoney(price);
    if (barPrice) barPrice.textContent = formatMoney(price);

    if (compareEl) {
      if (!isNaN(compare) && compare > price) {
        compareEl.textContent = formatMoney(compare);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  if (select && buttonWrap) {
    buttonWrap.hidden = false;
    select.style.display = 'none';

    var choices = buttonWrap.querySelectorAll('[data-variant-id]');
    choices.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        select.value = btn.dataset.variantId;
        choices.forEach(function (c) { c.classList.remove('is-on'); });
        btn.classList.add('is-on');
        syncPrice();
      });
    });
  }

  if (select) {
    select.addEventListener('change', syncPrice);
    syncPrice();
  }

  /* ---------- Photo upload confirmation ---------- */

  var photo = document.querySelector('[data-photo]');
  var photoOk = document.querySelector('[data-photo-ok]');

  if (photo && photoOk) {
    photo.addEventListener('change', function () {
      if (photo.files && photo.files.length) {
        var name = photo.files[0].name;
        photoOk.textContent = '✓ ' + (name.length > 34 ? name.slice(0, 31) + '…' : name);
        photoOk.classList.add('is-shown');
      } else {
        photoOk.classList.remove('is-shown');
      }
    });
  }

  /* ---------- Sticky buy bar ---------- */

  var bar = document.querySelector('[data-buybar]');
  var barBtn = document.querySelector('[data-buybar-btn]');
  var form = document.getElementById('product-form');

  if (bar && form) {
    var submitBtn = form.querySelector('button[name="add"]');

    var barIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-up', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    if (submitBtn) barIo.observe(submitBtn);

    if (barBtn) {
      barBtn.addEventListener('click', function () {
        // Scroll to the form rather than submitting — the customer still
        // needs to pick a variant and attach a photo.
        var target = photo || submitBtn;
        if (target) {
          target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          if (photo) setTimeout(function () { photo.focus(); }, reduced ? 0 : 420);
        }
      });
    }
  }

  /* ---------- Guard against submitting with no photo ---------- */

  if (form && photo) {
    form.addEventListener('submit', function (e) {
      if (!photo.files || !photo.files.length) {
        e.preventDefault();
        photo.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        photo.focus();

        var warn = document.querySelector('[data-photo-warn]');
        if (!warn) {
          warn = document.createElement('p');
          warn.setAttribute('data-photo-warn', '');
          warn.className = 'upload__hint';
          warn.style.color = 'var(--danger)';
          warn.style.fontWeight = '600';
          warn.style.marginTop = '10px';
          warn.textContent = 'Please add a photo — we need one to make your rakhi.';
          photo.parentNode.appendChild(warn);
        }
      }
    });
  }

})();
